// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ZoJrr","wrapper":"Header_wrapper__5QsQa","change__them":"Header_change__them__1oOa4","logo":"Header_logo__XKmsx","title":"Header_title__QXI52"};